import Rest from '@/services/Rest';

export default class TutorService extends Rest {
  static resource = 'tutor';
}
